import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from "@angular/router";
import { StoresService } from "../services/stores.service";

export const StoreResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(StoresService).fetchOneStore(
    route.paramMap.get("id")
  );
};
